import { message } from 'design-system';

import axios from 'src/services/axios';

import { toLogin } from '../../../utils';
import { Product, getAccessToken } from '../../../services/user';
import { STORAGE_KEY, STORAGEREFRESHTOKENKEY } from './auth-provider';

// ----------------------------------------------------------------------

function jwtDecode(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken: string) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

// ----------------------------------------------------------------------
let expiredTimer: NodeJS.Timeout;
export const tokenExpired = (exp: number) => {
  if (expiredTimer) clearTimeout(expiredTimer);
  const currentTime = Date.now();
  const refreshOffset = 10 * 60 * 1000;
  const timeLeft = exp * 1000 - currentTime - refreshOffset;
  const errorHandler = () => {
    message.alert({ content: '登录信息失效！', type: 'error' });
    localStorage.removeItem(STORAGE_KEY);
    expiredTimer && clearTimeout(expiredTimer);
    toLogin();
  };
  const refreshToken = async () => {
    try {
      const result = await getAccessToken(Product.AMOEBA);
      setSession(result.token);
      localStorage.setItem(STORAGEREFRESHTOKENKEY, result.refreshToken);
    } catch {
      const accessToken = localStorage.getItem(STORAGE_KEY);
      if (accessToken) {
        const { exp } = jwtDecode(accessToken);
        tokenExpired(exp);
        return;
      }
      errorHandler();
    }
  };
  if (exp * 1000 <= currentTime) {
    errorHandler();
    return;
  }
  if (timeLeft <= 0) {
    refreshToken();
    return;
  }
  expiredTimer = setTimeout(refreshToken, timeLeft);
};

// ----------------------------------------------------------------------

export const setSession = (accessToken: string | null) => {
  if (accessToken) {
    localStorage.setItem(STORAGE_KEY, accessToken);

    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    // This function below will handle when token is expired
    const { exp } = jwtDecode(accessToken); // ~3 days by minimals server
    tokenExpired(exp);
  } else {
    localStorage.removeItem(STORAGE_KEY);

    delete axios.defaults.headers.common.Authorization;
  }
};
